import { Environment } from './web-environment'

export const environment: Environment = {
  production: true,
  debugLogging: false,
}
